import { ChannelType, OrderStatus, ScheduledActionEnumAction, } from '@wix/ambassador-events-v1-order/types';
import { isTicketAssigned } from '..';
import { getValidGiftCardDetails } from '../gift-cards/gift-cards';
import { roundPrice } from '../price/utils';
export const isUnpaidOrder = (order) => isUnpaidOrderStatus(order?.status);
export const isUnpaidOrderStatus = (orderStatus) => orderStatus !== OrderStatus.PAID && orderStatus !== OrderStatus.FREE && orderStatus !== OrderStatus.VOIDED;
export const ticketHasSeatInfo = (ticket) => Boolean(ticket.ticketDetails?.seatId);
export const ticketsHaveSeatInfo = (tickets) => Boolean(tickets.find(ticketHasSeatInfo));
export const getTicketFormSubmissions = (ticket, order) => isTicketAssigned(ticket)
    ? ticket.guestDetails.formSubmission?.submissions || {}
    : order?.checkoutFormSubmission?.submissions || {};
export const isPosOrder = (order) => order.channel === ChannelType.OFFLINE_POS;
export const isOrderPending = (order) => order?.status === OrderStatus.PENDING;
export const isOrderAuthorized = (order) => order?.status === OrderStatus.AUTHORIZED;
export const isOrderVoided = (order) => order?.status === OrderStatus.VOIDED;
export const isOrderFree = (order) => order?.status === OrderStatus.FREE;
export const isOrderPaid = (order) => order?.status === OrderStatus.PAID;
export const isOrderEligibleForInvoice = (order) => Boolean(order?.contactId);
export const isOrderDeclined = (order) => order?.status === OrderStatus.DECLINED || order?.status === OrderStatus.VOIDED;
export const isOrderAutoVoid = (order) => isOrderAuthorized(order) && order.paymentDetails?.transaction?.scheduledAction === ScheduledActionEnumAction.VOID;
export const orderHasEmail = (order) => Boolean(order?.email);
export const getOrderGiftCardsTotalAmount = (giftCardPaymentDetails) => {
    const validGiftCardPaymentDetails = getValidGiftCardDetails(giftCardPaymentDetails);
    const currency = giftCardPaymentDetails?.[0]?.amount.currency ?? 'USD';
    const amount = validGiftCardPaymentDetails?.length
        ? validGiftCardPaymentDetails.reduce((total, details) => total + Number(details.amount.amount), 0)
        : 0;
    return Number(roundPrice(amount, currency));
};
export const getOrderCompletePaymentMethodTitle = (order, paymentMethod, otherPaymentMethodTitle, giftCardTitle) => {
    const paymentMethodTitle = paymentMethod || otherPaymentMethodTitle;
    return !getValidGiftCardDetails(order.giftCardPaymentDetails)?.length
        ? paymentMethodTitle
        : getOrderGiftCardsTotalAmount(order.giftCardPaymentDetails) === Number(order.invoice.grandTotal.amount)
            ? giftCardTitle
            : `${paymentMethodTitle}/${giftCardTitle}`;
};
export const getBuyerTotal = (total, giftCardPaymentDetails) => {
    const amount = Number(total.amount) - getOrderGiftCardsTotalAmount(giftCardPaymentDetails);
    const roundedAmount = roundPrice(amount, total.currency);
    return {
        amount: roundedAmount,
        value: roundedAmount,
        currency: total.currency,
    };
};
//# sourceMappingURL=order.js.map